import { useTrack } from '@hotjar/webapp/hooks/useTrack';

interface TrackingStatusTrackEvents {
  trackClick: (elementName: string, uiPosition?: string) => void;
}

export function useTrackingStatusTrack(): TrackingStatusTrackEvents {
  const { click: trackClick } = useTrack();

  return {
    trackClick: (elementName: string, uiPosition?: string) =>
      trackClick(elementName, uiPosition || 'Tracking Status', {}),
  };
}
